import { useEffect } from 'react';
import { carregarManifesto, hashDaFala, urlDaVoz } from './voz';

/**
 * Toca a fala de `texto` enquanto `podeFalar`.
 *
 * Trocou o texto (passo novo), a pessoa desligou a voz ou o balão saiu da
 * tela: a fala em curso para na hora. Fala ausente do manifesto ou autoplay
 * recusado pelo navegador não é erro: o tutorial segue só com o texto.
 */
export const useFala = (texto, podeFalar) => {
  useEffect(() => {
    if (!texto || !podeFalar) return undefined;

    let encerrada = false;
    let audio = null;

    carregarManifesto().then((lido) => {
      const fala = lido?.falas?.[hashDaFala(texto)];
      if (encerrada || !fala) return;
      audio = new Audio(urlDaVoz(fala.arquivo));
      // jsdom e navegadores antigos devolvem undefined em vez de promessa.
      audio.play()?.catch(() => {});
    });

    return () => {
      encerrada = true;
      audio?.pause();
    };
  }, [texto, podeFalar]);
};
